import "./EditWydarzenia.css"
import Icon from "../../../../components/elements/Icons/Icon";
import { getResponsiveImageVariables } from "../../../../utils/imagePosition";

export default function EditWydarzenia({ 
    title, 
    description, 
    date, 
    image, 
    previewImage,
    imagePosition,
    imagePositionMobile,
    imageStyle,
    imageStyleMobile,
    hex,
    previewMode = 'desktop'
}) {
    let currentImage = image ? `/uploads/events/${image}` : null

    if (previewImage) {
        currentImage = previewImage;
    }

    const baseStyle = {
        pointerEvents: 'none',
        userSelect: 'none',
        ...getResponsiveImageVariables(imagePosition, imagePositionMobile, imageStyle, imageStyleMobile),
    };

    return (
        <div className={`inline-pen event-card-shell event-card-shell-preview ${previewMode === 'mobile' ? 'event-card-mobile-preview' : ''}`}>
            <div className="container" style={{ borderColor: hex.secondary, '--event-background': hex.background }}>
                <div className="bg">
                    <div 
                        className="gradient-overlay"
                        style={{
                            background: `linear-gradient(to right, ${hex.background} 31%, rgba(0, 0, 0, 0) 100%)`
                        }}
                    ></div>
                    {currentImage ? (
                        <img
                            src={currentImage}
                            alt={title || ''}
                            style={baseStyle}
                            className="event-positioned-image"
                            draggable={false}
                            onError={() => {
                                try {
                                } catch {
                                }
                            }}
                        />
                    ) : (
                        <div className="no-image">
                            <span>Brak obrazu</span>
                        </div>
                    )}
                </div>
                <div className="content">
                    <h1 style={{ color: hex.primary }}>{title || ''}</h1>
                    <h4 style={{ color: hex.primary }}>{description || ''}</h4>

                    <div className="bottom-container">
                        <button style={{ color: hex.secondary, borderColor: hex.secondary }}>Zobacz więcej</button>
                        <div className="vertical-line" style={{ backgroundColor: hex.secondary }}></div>
                        <div className="date-block">
                            <Icon name={"calendar"} width={30} color={ hex.secondary } />
                            <span style={{ color: hex.secondary }}>{date || ''}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
